import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorderStatics} from "../TheBorderStatics";
import {TimelineLite} from "gsap";
import {TheBorder} from "../TheBorder";
import {TheBorderSymbol} from "../reels/TheBorderSymbol";

export class TheBorderXWaysView extends PIXI.Container implements StageLayer {
    constructor() {
        super();
        this.name = "TheBorderXWaysView";
        this.position = TheBorderStatics.MAIN_REELS_VIEW_POSITION;
    }

    public playAnimation(sym: TheBorderSymbol): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
                onComplete: () => {
                    if (item.parent) {
                        item.parent.removeChild(item);
                    }
                }
            }),
            textureNameHelper: string = (sym.sizeMultiplier === 0.5) ? "_H" : "";
        let item: PIXI.Sprite = new PIXI.Sprite(TheBorder.assetLoader.getTextures("X_WAYS" + textureNameHelper + "/" + "X_WAYS" + textureNameHelper)[0]);
        item.visible = false;
        item.anchor.set(0.5);
        item.position.set((sym.x + TheBorderStatics.reelPositions[sym.reelId].x), (sym.y - ((sym.sizeMultiplier === 0.5) ? 25 : 0)));

        tl.add(() => {
            item.visible = true;
            this.addChild(item);
        });
        tl.fromTo(item, {
            alpha: 0
        }, {
            alpha: 1,
            duration: 0.2
        });
        tl.to(item, {
            duration: 0.2,
            alpha: 0
        }, 0.4);

        return tl;
    }
}